import React from "react"
import {HeadFC, PageProps, graphql} from "gatsby"
import Seo from "../components/ui/seo/Seo";
import HorizontalLayout from "../components/ui/layout/HorizontalLayout";
import Header from "../sections/shared/header/Header";
import WaterBookContent from "../sections/whiteBook/waterBookContent/WaterBookContent";

const WaterWhiteBookPage: React.FC<PageProps> = ({location}) => (
    <>
        <main>
            <HorizontalLayout>
                <div style={{backgroundColor: '#FFF'}}>
                    <Header />
                </div>
                <WaterBookContent />
            </HorizontalLayout>
        </main>
    </>
);

export default WaterWhiteBookPage;

export const Head: HeadFC = ({location}) => (
    <Seo
        title='Livre blanc'
        description="Plongez à la découverte des enjeux de l’eau et de l’océan et des solutions pour les préserver dans ce nouveau livre blanc !"
        image="https://res.cloudinary.com/energic/image/upload/v1743496078/water_white_book_metaimage_xwil30.jpg"
        pathname={location.pathname}
    />
);

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
